{
  "alert": "Upozornenie",
  "dismiss": "Zrušiť"
}
